<mat-list>
  <mat-divider></mat-divider>
  <mat-list-item >
    <img
      matListItemAvatar
      src="./assets/images/sm-logga-2024-tr.png"
    />
    <div matListItemTitle>{{ selectedRace.raceName }}</div>
    <div matListItemLine>Equipe-id: {{selectedRace.equipeMeetingsID}}</div>
    <div matListItemLine>Arrangör: {{selectedRace.arrangingClubName }}</div>
    <button mat-raised-button class="import"
            color="primary" (click)="onImport(selectedRace)" >Importera Equipe-data
    </button>
  </mat-list-item>
  <mat-divider></mat-divider>
</mat-list>


